// Angular
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Local library
import { CommonFacade } from '@amwager/data-access';
import { MatNotificationService } from '@amwager/util';

// Local file
import { FundingFacade } from '../+state';
import { FundingService } from './funding.service';

/** Business logic for the deposit online-check (ACH) component. */
@Injectable()
export class DepositOnlineCheckService {

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly fundingFacade: FundingFacade,
    private readonly commonFacade: CommonFacade,
    private readonly matNotificationService: MatNotificationService,
    private readonly fundingService: FundingService,
  ) {}

  /** Build the online-check form. */
  buildForm(): FormGroup {
    return this.formBuilder.group({
      amount: ['', [Validators.required, Validators.minLength(25), Validators.maxLength(1000)]]
    });
  }

  /** Current TMS id stream. */
  tmsId$() {
    return this.commonFacade?.tmsId$();
  }

  /** Load the saved ACH accounts. */
  loadAccounts$() {
    this.fundingFacade.getAchAccount();
    return this.fundingFacade.getAchAccountList$();
  }

  /** Load the customer funding limits. */
  loadFundingLimit$() {
    this.fundingFacade.getFundingLimit();
    return this.fundingFacade.getFundingLimitList$();
  }

  /** Load the pending ACH deposits. */
  loadPendingAch$() {
    this.fundingFacade.getPendingAch();
    return this.fundingFacade.getPendingAchList$();
  }

  /** Dispatch the ACH deposit and stream the result. */
  deposit$(amount: number, bankAccountId: string | number, tmsId?: string) {
    this.fundingFacade.depositOnlineCheck(amount, bankAccountId, tmsId);
    return this.fundingFacade.isDepositOnlineCheckSuccess$();
  }

  /** Ask the user to confirm removing a bank account. */
  confirmRemoveAccount$() {
    return this.matNotificationService.showAlert(
      'Confirmation',
      'Are you sure about removing this bank account?',
      undefined,
      'Yes',
      'Cancel'
    );
  }

  /** Delete an ACH account and stream the result. */
  delete$(bankAccountId: string | number) {
    this.fundingFacade.deleteAchAccount(bankAccountId);
    return this.fundingFacade.isDeleteAchAccountSuccess$();
  }

  /** Mark all controls touched to reveal validation messages. */
  markFormGroupTouched(formGroup: FormGroup): void {
    this.fundingService.markFormGroupTouched(formGroup);
  }

  /** Show a single-button alert. */
  showAlert(header: string, message: string): void {
    this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
  }

}
